import { PureComponent } from 'react'
import { CheckOutlined } from '@ant-design/icons'
import { Radio, Card } from 'antd'
import classnames from 'classnames'

import Button from '~/core/Button'
import {
    TOP,
    BOTTOM,
    FRONT,
    BACK,
    LEFT,
    RIGHT,
    SELECT_MODE,
    ANNOTATION_MODE,
    CROSS_SECTION_ANNOTATION_MODE,
    CROSS_SECTION_MODE,
} from '~/redux-modules/qmr-viewer/constants'

import styles from './styles.css'

const SIDE = 'side'

const PLACEMENT = 'viewer-controls-bar'

class ColorPalette extends PureComponent {
    renderColor = color => {
        const { selectedPaletteColor } = this.props
        const selected = color === selectedPaletteColor

        const classNames = classnames({
            [styles.swatch]: true,
            [styles.selected]: selected,
        })

        return (
            <li
                key={color}
                onClick={this.props.setColor(color)}
                style={{ backgroundColor: color }}
                className={classNames}
            >
                {selected && <CheckOutlined />}
            </li>
        )
    }

    render() {
        const { paletteColors } = this.props

        return (
            <ul className={styles.palette}>
                {paletteColors.map(this.renderColor)}
            </ul>
        )
    }
}

export default class ControlsBar extends PureComponent {
    InteractionControlBox() {
        let inner

        switch (this.props.interactionMode) {
            case SELECT_MODE: {
                const { selectedPaletteColor, paletteColors } = this.props

                inner = (
                    <ColorPalette
                        selectedPaletteColor={selectedPaletteColor}
                        paletteColors={paletteColors}
                        setColor={this.props.setColor}
                    />
                )
                break
            }
            case CROSS_SECTION_MODE:
                inner = (
                    <>
                        {this.PlaneButton(FRONT, 'Front plane')}
                        {this.PlaneButton(TOP, 'Top plane')}
                        {this.PlaneButton(SIDE, 'Side plane')}
                    </>
                )
                break
            default:
                inner = null
        }

        if (inner == null) {
            return null
        }

        return (
            <Card
                className={styles.interactionCard}
                bodyStyle={{ padding: '8px' }}
            >
                {inner}
            </Card>
        )
    }

    PlaneButton(plane, text) {
        return (
            <Button
                onClick={this.onChangeView(plane)}
                style={styles}
                name={`${plane}-button`}
                placement={PLACEMENT}
                className={styles.planeButton}
            >
                {text}
            </Button>
        )
    }

    onChangeView(plane) {
        const { setCrossSectionView, crossSectionConfig } = this.props

        return () => {
            let view

            switch (plane) {
                case FRONT:
                    view = crossSectionConfig?.view === FRONT ? BACK : FRONT
                    break
                case TOP:
                    view = crossSectionConfig?.view === TOP ? BOTTOM : TOP
                    break
                case SIDE:
                    view = crossSectionConfig?.view === RIGHT ? LEFT : RIGHT
                    break
                default:
                    view = FRONT
            }

            return setCrossSectionView(view)
        }
    }

    onChange({ target: { value: mode } }) {
        this.props.setInteractionMode(mode)
    }

    render() {
        const { interactionMode: viewerInteractionMode } = this.props

        const interactionMode =
            viewerInteractionMode === CROSS_SECTION_ANNOTATION_MODE
                ? ANNOTATION_MODE
                : viewerInteractionMode

        return (
            <div className={styles.controlsPanel}>
                {this.InteractionControlBox()}
                <Radio.Group
                    buttonStyle="solid"
                    value={interactionMode}
                    onChange={this.onChange.bind(this)}
                >
                    <Radio.Button value={SELECT_MODE}>
                        Select surface
                    </Radio.Button>
                    <Radio.Button value={ANNOTATION_MODE}>
                        Drop-pin
                    </Radio.Button>
                    <Radio.Button value={CROSS_SECTION_MODE}>
                        Cross-section
                    </Radio.Button>
                </Radio.Group>
            </div>
        )
    }
}
